// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Switcher__container{font:var(--main-font);white-space:nowrap}.Switcher__label{font-weight:700;font-size:11px;margin-bottom:7px}.Switcher__item+.Switcher__item{margin-left:5px}", "",{"version":3,"sources":["webpack://./client/components/Switcher.css"],"names":[],"mappings":"AAAA,qBACE,qBAAsB,CACtB,kBACF,CAEA,iBACE,eAAiB,CACjB,cAAe,CACf,iBACF,CAEA,gCACE,eACF","sourcesContent":[".container {\n  font: var(--main-font);\n  white-space: nowrap;\n}\n\n.label {\n  font-weight: bold;\n  font-size: 11px;\n  margin-bottom: 7px;\n}\n\n.item + .item {\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "Switcher__container",
	"label": "Switcher__label",
	"item": "Switcher__item"
};
export default ___CSS_LOADER_EXPORT___;
